import store from "@/store";

let countingDownInterval;
let countingDownInterval2;

const util = {};
util.versions = () => {
  let u = navigator.userAgent,
    app = navigator.appVersion;
  return {
    trident: u.indexOf("Trident") > -1, //IE内核
    presto: u.indexOf("Presto") > -1, //opera内核
    webKit: u.indexOf("AppleWebKit") > -1, //苹果、谷歌内核
    gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1, //火狐内核
    mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
    ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
    android: u.indexOf("Android") > -1 || u.indexOf("Adr") > -1, //android终端
    iPhone: u.indexOf("iPhone") > -1, //是否为iPhone或者QQHD浏览器
    iPad: u.indexOf("iPad") > -1, //是否iPad
    webApp: u.indexOf("Safari") == -1, //是否web应该程序，没有头部与底部
    weixin: u.indexOf("MicroMessenger") > -1, //是否微信 （2015-01-22新增）
    qq: u.match(/\sQQ/i) == " qq", //是否QQ
    u: u
  };
};
util.systemType=()=>{
  var agent = navigator.userAgent.toLowerCase();
  var isMac = /macintosh|mac os x/i.test(navigator.userAgent);
  if(isMac){
    return true
  }else{
    return false
   }

};
// 判断是否为微信环境
util.isWeixin=()=>{
  var ua = navigator.userAgent.toLowerCase();
  return ua.match(/MicroMessenger/i) == "micromessenger";
}

//验证码倒计时
util.countingDownVerifyCode = (fun, newStart = false) => {
  if (store.state.countingDown > 0 && store.state.countingDown < 60) {
    clearInterval(countingDownInterval);
    util.doCounting(fun);
  } else if (newStart) {
    clearInterval(countingDownInterval);
    store.commit("setValue", ["countingDown", 60]);
    window.localStorage.setItem("countingDown", store.state.countingDown);
    util.doCounting(fun);
  }
};

util.clearInterval1 = () => {
  clearInterval(countingDownInterval);
  store.commit("setValue", ["countingDown", 0]);
  window.localStorage.setItem("countingDown", store.state.countingDown);
};

//验证码倒计时
util.doCounting = fun => {
  countingDownInterval = setInterval(() => {
    if (store.state.countingDown > 0) {
      store.commit("setValue", ["countingDown", store.state.countingDown - 1]);
      window.localStorage.setItem("countingDown", store.state.countingDown);
      if (fun) {
        fun(store.state.countingDown + "");
      }
    } else {
      console.log("清除定时器");
      if (fun) {
        fun("获取验证码");
      }
      clearInterval(countingDownInterval);
    }
  }, 1000);
};
//验证码倒计时2
util.countingDownVerifyCode2 = (fun, newStart = false) => {
  if (store.state.countingDown2 > 0 && store.state.countingDown2 < 60) {
    clearInterval(countingDownInterval2);
    util.doCounting2(fun);
  } else if (newStart) {
    clearInterval(countingDownInterval2);
    store.commit("setValue", ["countingDown2", 60]);
    window.localStorage.setItem("countingDown2", store.state.countingDown2);
    util.doCounting2(fun);
  }
};

util.clearInterval2 = () => {
  clearInterval(countingDownInterval2);
  store.commit("setValue", ["countingDown2", 0]);
  window.localStorage.setItem("countingDown2", store.state.countingDown2);
};
//验证码倒计时2
util.doCounting2 = fun => {
  countingDownInterval2 = setInterval(() => {
    if (store.state.countingDown2 > 0) {
      store.commit("setValue", [
        "countingDown2",
        store.state.countingDown2 - 1
      ]);
      window.localStorage.setItem("countingDown2", store.state.countingDown2);
      if (fun) {
        fun(store.state.countingDown2 + "");
      }
    } else {
      console.log("清除定时器");
      if (fun) {
        fun("获取验证码");
      }
      clearInterval(countingDownInterval2);
    }
  }, 1000);
};
//保存token
util.setToken = token => {
  localStorage.setItem("token", token);
  store.commit("setValue", ["access_token", token]);
};

export function getFriendlyUrlType(callback, params, that, type) {
  var friendlyUrlType = "";
  var linkStr = [];
  var systemType = "ALLPAGE"; //所有页面
  var obj = {};
  if (params.link.indexOf("/custom") != -1) {
    friendlyUrlType = "CUSTOM";
    linkStr = params.link.split("/custom/");
  } else if (params.link.indexOf("/shopping") != -1) {
    friendlyUrlType = "SHOPPING";
    linkStr = params.link.split("/shopping/");
  } else if (params.link.indexOf("/sets") != -1) {
    friendlyUrlType = "SETS";
    linkStr = params.link.split("/sets/");
  } else if (params.link.indexOf("/article") != -1) {
    friendlyUrlType = "ARTICLE";
    linkStr = params.link.split("/article/");
  } else if (params.link.indexOf("/collection") != -1) {
    friendlyUrlType = "COLLECTION";
    linkStr = params.link.split("/collection/");
  } else if (params.link.indexOf("/stores") != -1) {
    friendlyUrlType = "STORES";
    linkStr = params.link.split("/stores/");
  } else {
    systemType = "";
    friendlyUrlType = "OTHER";
    linkStr = linkStr[1];
  }

  obj.friendlyUrlType = friendlyUrlType;
  obj.friendly_url = linkStr;
  obj.systemType = systemType;
  return obj;
}

export function checkLinkUrl(callback, params, that, type) {
  var linkStr = [];
  if (params.link.indexOf("/custom") != -1) {
    linkStr = params.link.split("/custom/");
    var obj = {
      name: "custom",
      params: {
        friendly_url: linkStr[1]
      }
    };
    if (params.newWindows) {
      let routeUrl = that.$router.resolve(obj);
      window.open(routeUrl.href, "_blank");
    } else {
      that.$router.push(obj);
    }
  } else if (params.link.indexOf("/shopping") != -1) {
    linkStr = params.link.split("/shopping/");
    var obj = {
      name: "shopping",
      params: {
        friendly_url: linkStr[1]
      }
    };
    if (params.newWindows) {
      let routeUrl = that.$router.resolve(obj);
      window.open(routeUrl.href, "_blank");
    } else {
      that.$router.push(obj);
    }
  }else if(params.link.indexOf("/fits") != -1){
    that.$router.push(params.link);
  } else if (params.link.indexOf("/sets") != -1) {
    linkStr = params.link.split("/sets/");

    var obj = {
      name: "sets",
      params: {
        friendly_url: linkStr[1]
      }
    };
    if (params.newWindows) {
      let routeUrl = that.$router.resolve(obj);
      window.open(routeUrl.href, "_blank");
    } else {
      that.$router.push(obj);
    }
  } else if (params.link.indexOf("/article") != -1) {
    linkStr = params.link.split("/article/");
    var obj = {
      name: "article",
      params: {
        friendly_url: linkStr[1]
      }
    };
    if (params.newWindows) {
      let routeUrl = that.$router.resolve(obj);
      window.open(routeUrl.href, "_blank");
    } else {
      that.$router.push(obj);
    }
  } else if (params.link.indexOf("/collection") != -1) {
    //图集男女
    if (
      params.link == "/collections/archive/man" ||
      params.link == "collections/archive/man" ||
      params.link == "/collections/archive/woman" ||
      params.link == "collections/archive/woman"
    ) {
      var obj = {
        name: params.link,
        params: {}
      };
      if (params.newWindows) {
        let routeUrl = that.$router.resolve(obj);
        window.open(routeUrl.href, "_blank");
      } else {
        that.$router.push(obj);
      }
    } else {
      //图集friendly_url
      linkStr = params.link.split("/collection/");
      let newful = linkStr[1].split('/');
      var obj = {
        name: "collection",
        params: {
          friendly_url: newful[0],
          content:newful[1] ||  "" || undefined,
        }
      };

      if (params.newWindows) {
        let routeUrl = that.$router.resolve(obj);
        window.open(routeUrl.href, "_blank");
      } else {
        that.$router.push(obj);
      }
    }
  } else if (params.link.indexOf("/stores") != -1) {
    linkStr = params.link.split("/stores/");
    var obj = {
      name: "stores",
      params: {
        friendly_url: linkStr[1]
      }
    };
    if (params.newWindows) {
      let routeUrl = that.$router.resolve(obj);
      window.open(routeUrl.href, "_blank");
    } else {
      that.$router.push(obj);
    }
  } else if (params.link.indexOf("/store-detail") != -1) {
    linkStr = params.link.split("/store-detail/");
    var obj = {
      name: "store-detail",
      params: {
        friendlyUrl: linkStr[1]
      }
    };
    if (params.newWindows) {
      let routeUrl = that.$router.resolve(obj);
      window.open(routeUrl.href, "_blank");
    } else {
      that.$router.push(obj);
    }
  } else {
    var reg_user = /(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/;
    if (reg_user.test(params.link)) {
      //外部链接
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        //手机
        window.location.href = params.link;
      } else {
        //pc
        var tempwindow = window.open("_blank");
        tempwindow.location = params.link;
      }
    } else {
      
      if (params.newWindows) {
        let routeUrl = that.$router.resolve({
          name: params.link.split("/")[1],
          params: {}
        });

        if (routeUrl.href.indexOf("/") != -1) {
         
          if (routeUrl.href == "/") {
            that.$router.push(params.link);
          } else {
            window.open(params.link, "_blank");
          }
        } else {
         
          that.$router.push(params.link);
        }
      } else {
        that.$router.push(params.link);
      }
    }
  }
}

function redirectbyLinkUrlto404(that,path){
  let paths=sessionStorage.getItem('mypaths')?JSON.parse(sessionStorage.getItem('mypaths')) :[];
  let path2=paths[paths.length-1];
  return new Promise((resolve, reject) => {
    let url=that.$store.state.API.tracking.tbMiss;
    let params={
      merchanId:that.$store.state.storeId,
      url1:path,
      url2:path2
    }
    that.$http.get(url + "?" + that.$qs.stringify(params)).then(res=>{
      if(res.data.result){
        sessionStorage.setItem('mypaths',JSON.stringify([]))
      }
    })
  })
};
function setPathsbysessionStorage(path){
  return new Promise((resolve, reject) => {
    let paths=sessionStorage.getItem('mypaths')?JSON.parse(sessionStorage.getItem('mypaths')) :[]
    paths.push(path);
    paths=paths.slice(-2)
    sessionStorage.setItem('mypaths',JSON.stringify(paths))
  })
};
export function getEntityIdByLinkUrl(callback, params, that, type,pagefrom) {
  let url = that.$store.state.API.plp.getEntityIdByLinkUrl(); //getByLinkAndType
  let paramsObj = {
    friendlyUrlType: params.friendlyUrlType,
    link: params.link
  };
  that.$http
    .post(url, paramsObj, {
      "Content-Type": "application/json"
    })
    .then(res => {
      if (res.data.message == "success" && res.data.returnData) {
        setPathsbysessionStorage(window.location.href)
        callback(res.data.returnData);
      } else {
        if(pagefrom=='fit'){
          that.loading = false;
          return;
        }
        that.loading = false;
     
        redirectbyLinkUrlto404(that,window.location.href)
        that.$router.push({name:"404",query:{type:1}});
      
        // 如果直接这里就说明就一级

      }
    });
}
export function getEntityIdByLink(callback, params, that, type) {
  let url = that.$store.state.API.plp.getEntityIdByLinkUrl(); //getByLinkAndType
  let paramsObj = {
    friendlyUrlType: params.friendlyUrlType,
    link: params.link
  };
  that.$http
    .post(url, paramsObj, {
      "Content-Type": "application/json"
    })
    .then(res => {
      if (res.data.message == "success" && res.data.returnData) {
        callback(res.data.returnData);
      } else {
        callback(res.data.returnData);
      }
    });
}
export function setHeaderTop(callback, params, that, type) {
  var refound = $(".refound").html();
  if (refound) {
    if (params.screenWidth > 768) {
      document.getElementById("main").style.paddingTop = "101px";
    } else {
      if (params.page == "home" || params.page == "") {
        // if ($(".mobdata").html() > 0) {
        //     document.getElementById("main").style.paddingTop = "34px";
        // } else {
        //     document.getElementById("main").style.paddingTop = "124px";
        // }
      } else {
        document.getElementById("main").style.paddingTop =
          document.getElementById("header-container-mb").clientHeight + "px";
      }
    }
  } else {
    if (params.screenWidth > 768) {
      document.getElementById("main").style.paddingTop = "66px";
    } else {
      if (params.page == "home" || params.page == "") {
        // if ($(".mobdata").html() > 0) {
        //     document.getElementById("main").style.paddingTop = "0px";
        // } else {
        //     document.getElementById("main").style.paddingTop = "90px";
        // }
      } else {
        document.getElementById("main").style.paddingTop =
          document.getElementById("header-container-mb").clientHeight + "px";
      }
    }
  }
}
export function isSupportWebp(that) {
  try {
    var webp =
      document
        .createElement("canvas")
        .toDataURL("image/webp", 0.5)
        .indexOf("data:image/webp") === 0;
    window.localStorage.setItem("isSupportWebp", webp);
  } catch (err) {
    window.localStorage.setItem("isSupportWebp", false);
  }
}
util.setPathsbysessionStorage=setPathsbysessionStorage;
util.updateImgOssSuffix = (that, type) => {
  // console.log("updateImgOssSuffix")
  that.$nextTick(() => {
    var isSupportWebp = window.localStorage.getItem("isSupportWebp");
    // console.log("isSupportWebp" + typeof isSupportWebp)
    var ossSuffix = that.$store.state.ossSuffix;
    // console.log("ossSuffix" + ossSuffix)
    $("#app img").each(function(i) {
      let imgsec = $(this).attr("src");
      if (isSupportWebp == "true" || isSupportWebp == true) {
        if (
          imgsec.indexOf("https://oss-cn-shanghai.aliyuncs.com") > -1 &&
          imgsec.indexOf("?x-oss-process=style/tb") <= 0
        ) {
          imgsec = imgsec + ossSuffix;
          $(this).attr("src", imgsec);
        }
      } else {
        // $(this).attr("src", imgsec);
      }
    });
  });
};
util.isMobile = () => {
  if (
    navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
  ) {
    return true;
  } else {
    return false;
  }
},
util.checkIsUpdatetoWebp = (that, imgsec) => {
  if(!imgsec) return true;
  let flag =
    (window.localStorage.getItem("isSupportWebp") == "true" &&
      imgsec.indexOf("?x-oss-process=style/tb") == -1) ||
    (window.localStorage.getItem("isSupportWebp") == true &&
      imgsec.indexOf("?x-oss-process=style/tb") == -1);
  return flag;
};

util.checkIsSupportWebp = (that, imgsec) => {
  if(!imgsec) return true;
  let flag =
    (window.localStorage.getItem("isSupportWebp") == "true"  ||
    window.localStorage.getItem("isSupportWebp") == true );
  return flag;
};

util.toThousands = function(num, point = 2) {
  if (num == null) return;
  num = num.toString();
  if (num.indexOf("元起") > -1) {
    num = num.replace("元起", "");
    num = parseFloat(num);
  } else {
    num = parseFloat(num);
  }
  if (num <= 1000) {
    return num;
  } else {
    let [sInt, sFloat] = (Number.isInteger(num)
      ? `${num}`
      : num.toFixed(point)
    ).split(".");
    sInt = sInt.replace(/\d(?=(\d{3})+$)/g, "$&,");
    return sFloat ? `${sInt}.${sFloat}` : `${sInt}`;
  }
};
util.replaceImage = (img)=>{
  if(img!=null){
    return img.replace("https://oss-cn-shanghai.aliyuncs.com/connectplus/","https://static.getconnectplus.com/") 
  }else{
    return img;
  }
};
//数据监测封装
function getIpaddress(that){
  return new Promise((resolve,reject)=>{
    let url=that.$store.state.API.tracking.getIp;
    that.$http.get(url).then(res=>{
      resolve(res)
    })
  })
};
function getBrowserNameAndVersion(){
  var agent = navigator.userAgent.toLowerCase();
  var regStr_ie = /msie [\d.]+/gi ;
  var regStr_ff = /firefox\/[\d.]+/gi
  var regStr_chrome = /chrome\/[\d.]+/gi ;
  var regStr_saf = /safari\/[\d.]+/gi ;
  var browserNV = "";
  //IE
  if(agent.indexOf("msie") > 0)
  {
    browserNV = agent.match(regStr_ie) ;
  }
  //firefox
  if(agent.indexOf("firefox") > 0)
  {
    browserNV = agent.match(regStr_ff) ;
  }
  //Chrome
  if(agent.indexOf("chrome") > 0)
  {
    browserNV = agent.match(regStr_chrome) ;
  }
  //Safari
  if(agent.indexOf("safari") > 0 && agent.indexOf("chrome") < 0)
  {
    browserNV = agent.match(regStr_saf) ;
  }
  browserNV = browserNV.toString();
  //other
  if(""==browserNV){
    browserNV  = "Is not a standard browser";
  }
  //Here does not display "/"
  if(browserNV.indexOf('firefox')!= -1 || browserNV.indexOf('chrome')!= -1){
    browserNV = browserNV.replace("/","");
  }
  //Here does not display space
  if(browserNV.indexOf('msie')!= -1){
   //msie replace IE & trim space
   browserNV = browserNV.replace("msie","ie").replace(/\s/g,"");
  }
  //return eg:ie9.0 firefox34.0 chrome37.0
 return browserNV;
};
util.searchLogAdd=(that,name,tourist=0)=>{

  return new Promise((resolve, reject) => {
    let OpenId='';
    let url=store.state.API.tracking.searchLogAdd;
    let userInfo = window.localStorage.getItem("userInfo") || "{}";
    userInfo = JSON.parse(userInfo);
    util.CheckOpenIdExist(that).then(res=>{
       OpenId=res;
      if(OpenId||userInfo.id){
        if(OpenId){
          OpenId=res;
        }else{
          OpenId=userInfo.id
        }
        let params={
          merchanId:store.state.storeId, 
          ip:OpenId, 
          gender:userInfo.gender?userInfo.gender:0,
          name:name,
          tourist:tourist
        };
        that.$http.get(url + "?" + that.$qs.stringify(params)).then(res=>{
    
        }).catch(err=>{
    
        })
      }else{
        getIpaddress(that).then(ress=>{
          OpenId=ress.data.returnData;
          let params={
            merchanId:store.state.storeId, 
            ip:OpenId, 
            gender:userInfo.gender?userInfo.gender:0,
            name:name,
            tourist:tourist
          };
          that.$http.get(url + "?" + that.$qs.stringify(params)).then(res=>{
      
          }).catch(err=>{
      
          })
        })
      
       
      }
      // console.log(userInfo,'userInfo')
      // console.log(store.state,'store.state')
     
    });

  })
};
util.trackData=(that,pageName,baseId,index)=>{
  return new Promise((resolve, reject)=>{
    let url=store.state.API.tracking.addTb;
    let userInfo = window.localStorage.getItem("userInfo") || "{}";
    userInfo = JSON.parse(userInfo);
    
    util.CheckOpenIdExist(that).then(res=>{
      // console.log(res,'取openid')
      let userAgentStr =getBrowserNameAndVersion();
      // console.log(userAgentStr,"userAgentStr")
      //如果OpenId为空就用ip地址
      let OpenId=res;
      if(OpenId||userInfo.id){
        if(OpenId){
          OpenId=res;
        }else{
          OpenId=userInfo.id
        }
      }else{
        getIpaddress(that).then(ress=>{
          OpenId=ress.data.returnData;
          let params={
            merchanId:store.state.storeId, 
            ip:OpenId, 
            baseId:baseId, 
            gender:userInfo.gender?userInfo.gender:0, 
            pageName:pageName, 
            terminal:userAgentStr,
            source:'website',
            index:index,
            channelId:'',
            activityId:''
          };
          that.$http.get(url + "?" + that.$qs.stringify(params)).then(res=>{
          
          }).catch(err=>{
            
          })
        });
        return;
      }
      let params={
        merchanId:store.state.storeId, 
        ip:OpenId, 
        baseId:baseId, 
        gender:userInfo.gender?userInfo.gender:0, 
        pageName:pageName, 
        terminal:userAgentStr,
        source:'website',
        index:index,
        channelId:'',
        activityId:''
      };
      that.$http.get(url + "?" + that.$qs.stringify(params)).then(res=>{
       
      }).catch(err=>{
       
      })
    });
   
   

  })
};
//检查是否有openid
util.CheckOpenIdExist = that => {
  return new Promise((resolve, reject) => {
    let userInfo = window.localStorage.getItem("userInfo") || "{}";
    // console.log(userInfo,'是很好')
    userInfo = JSON.parse(userInfo);
    if (userInfo.openId) {
      //   console.log(userInfo.openId,'进行测试1')
      resolve(userInfo.openId);
    } else {
      //如何
      var url = store.state.API.my.getUserInfo;
      that.$http
        .get(url, {
          headers: { tb_token: window.localStorage.getItem("token") }
        })
        .then(res => {
          // console.log(res,'进行测试2')
          if (res.data.returnCode == "005" && !res.data.result) {
            //没有登录 或是失效
            resolve("");
          } else {
            if (res.data.returnData.openId) {
              window.localStorage.setItem(
                "userInfo",
                JSON.stringify(res.data.returnData)
              );
              store.commit("resetUserInfo", res.data.returnData);
            }
            resolve(res.data.returnData.openId);
            // console.log(res.data.returnData, '进行测试3')
          }
        })
        .catch(err => {});
    }
    // console.log(userInfo.openId, '进行测试')
  });
};
util.check_support_webp = function() {
  let flag =
    window.localStorage.getItem("isSupportWebp") == "true" ||
    window.localStorage.getItem("isSupportWebp") == true;
  return flag;
};
/**
 * 检测图片是否存在
 * @param url
 */
util.imageIsExist = function(url) {
  return new Promise(resolve => {
    var img = new Image();
    img.onload = function() {
      if (this.complete == true) {
        resolve(true);
        img = null;
      }
    };
    img.onerror = function() {
      resolve(false);
      img = null;
    };
    img.src = url;
  });
};

/**
 * 根据friendly url 获取对应的SEO信息
 * @param {} url 
 * @returns 
 */

let head = document.getElementsByTagName('head');
let meta = document.createElement('meta');
let meta1 = document.createElement('meta');
util.setSeoInfo = function(info, that,flag) {
  if(info.seoTitle){
      // document.title=  flag =='not' ?  info.seoTitle :info.seoTitle +that.$store.state.titleSuffix 

      document.title = info.seoTitle;
  }
  if(info.keyWords){
    meta.content = info.keyWords;
    meta.name = "keywords";
    head[0].appendChild(meta);
  }else{
    meta.remove();
  }
  if(info.describtion){
    meta1.content = info.describtion;
    meta1.name = "description";
    head[0].appendChild(meta1);
  }else{
    meta1.remove();
  }

};

util.getEntityAndSetSeoInfo = function(params, that) {

  let url = that.$store.state.API.plp.getEntityIdByLinkUrl(); //getByLinkAndType
  let paramsObj = {
    friendlyUrlType: params.friendlyUrlType,
    link: params.link
  };
  that.$http
    .post(url, paramsObj, {
      "Content-Type": "application/json"
    })
    .then(res => {
      if (res.data.message == "success" && res.data.returnData) {
        this.setSeoInfo(res.data.returnData,that,'not');
      }
    });
 
};

// setSeo(){
//   const that = this;
//    let params = {
//      friendlyUrlType: "STORES",
//      link: this.$route.params.friendlyUrl
//    };
//    getEntityIdByLinkUrl(
//      function(data) {
//        that.$utils.setSeoInfo(data,that);
//      },
//      params,
//      this
//    );
//    },


export default util;



// WEBPACK FOOTER //
// ./src/utils/utils.js